export default __webpack_public_path__ + "static/media/logo_codelco.fb11a50c.png";